import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Wrapper, ButtonsWrapper, Button } from './styles';

interface ToggleProps {
	items: {
		id: number | string;
		label: string;
	}[];
	activeId: number | string;
	onItemClick: (id: number | string) => void;
	width?: string;
}

const Toggle = ({ items, activeId, onItemClick, width }: ToggleProps) => (
	<Wrapper>
		<ButtonsWrapper>
			{items.map(({ id, label }) => (
				<Button
					key={id}
					type="button"
					isActive={id === activeId}
					width={width}
					onClick={() => onItemClick(id)}
				>
					<Translate value={label} />
				</Button>
			))}
		</ButtonsWrapper>
	</Wrapper>
);

export default Toggle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Toggle/index.tsx